import { AspectRatio, Box, Image, Stack } from "@chakra-ui/react";
import { Suspense, lazy, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Footer } from "./components/Footer/Footer";
import { Navigation } from "./components/header/Navigation";
import { About } from "./components/main/About";
import { Advantege } from "./components/main/Advantege";
import { CallAction } from "./components/main/CallAction";
import { FAQ } from "./components/main/FAQ";
import { MainInfo } from "./components/main/MainInfo";
import { References } from "./components/main/References";
import { Satisfied } from "./components/main/Satisfied";
import { Success } from "./components/main/Success";
import { Team } from "./components/main/Team";
import { useContaxt } from "./context/Context";
import header from "./images/webdesigner_webentwickler_team_webwerk_am_meer.webp";
import { aggregateRating } from "./rich-snippets/aggregateRating";
import { faqSnippet } from "./rich-snippets/faqSnippet";
import { ReferenceSlider } from "./components/references/ReferenceSlider";

const TimedModal = lazy(() =>
  import("./components/TimedModal").then((m) => ({ default: m.TimedModal }))
);

export function App() {
  const home = useRef();
  const success = useRef();
  const team = useRef();
  const [shouldLoadTimedModal, setShouldLoadTimedModal] = useState(false);
  const { variant } = useContaxt();

  useEffect(() => {
    const id = window.setTimeout(() => {
      setShouldLoadTimedModal(true);
    }, 0);
    return () => window.clearTimeout(id);
  }, []);

  return (
    <>
      <Suspense fallback={null}>
        {shouldLoadTimedModal ? <TimedModal /> : null}
      </Suspense>
      <Helmet>
        <script type="application/ld+json">{faqSnippet}</script>
        <script type="application/ld+json">{aggregateRating}</script>
      </Helmet>
      <Navigation refs={[home, success, team]} />
      <Box as="main" role="main">
        <Box
          w={"100%"}
          overflow={"hidden"}
          pt={variant !== "lg" ? ["70px", "90px", "90px", "90px"] : undefined}
        >
          <AspectRatio ratio={16 / 9} w={"100%"}>
            <Image
              h={"100%"}
              w={"100%"}
              objectFit="cover"
              loading="eager"
              decoding="async"
              fetchPriority="high"
              alt={
                "Das junge dynamische Team der Webentwicklungs- und Webdesign Agentur WebWerk am Meer"
              }
              src={header}
              title="Das junge dynamische Team der Webentwicklungs- und Webdesign Agentur WebWerk am Meer"
            />
          </AspectRatio>
        </Box>
        <Stack
          spacing={["60px", "70px", "100px", "120px", "150px"]}
          pt={"80px"}
        >
          <MainInfo componentRef={home} />
          <ReferenceSlider />
          <Satisfied />
          <References />
          <Success componentRef={success} />
          <Advantege />
          <About />
          <CallAction />
          <Team componentRef={team} />
          <FAQ />
          <Footer />
        </Stack>
      </Box>
    </>
  );
}

export default App;
